import { useState } from "react";
import { Img, Reveal } from "@/components/site/Motion";
import { Lightbox } from "@/components/site/Lightbox";

const Tag = ({ kind }) => {
  const strong = kind === "verified" || kind === "project";
  return (
    <span className={`inline-flex max-w-full items-center rounded-md px-2 py-0.5 text-[11px] font-semibold uppercase tracking-[0.1em] ${strong ? "bg-[#102A43] text-white" : "border border-[#B8C5D1] bg-white text-[#3E5468]"}`}>
      {{ verified: "Alumicom work", project: "Alumicom project" }[kind] || "System example"}
    </span>
  );
};

export const WorkCard = ({ it, sizes = "(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw" }) => (
  <figure className="h-full">
    <div className="img-frame aspect-[4/3]">
      <Img name={it.name} alt={it.alt} w={it.w} h={it.h} sizes={sizes} className="h-full w-full object-cover transition-transform duration-700 ease-out hover:scale-[1.03]" />
    </div>
    <figcaption className="mt-4">
      <Tag kind={it.kind} />
      {it.kind === "verified" ? (
        <>
          <p className="mt-3 text-sm font-semibold text-[#151A20] md:text-base">{it.setting}</p>
          <dl className="mt-2 grid gap-1 text-[13px] text-[#2B3642] md:text-sm">
            <div className="flex flex-wrap gap-x-2"><dt className="text-[#4A5866]">Stage:</dt><dd className="min-w-0">{it.stage}</dd></div>
            <div className="flex flex-wrap gap-x-2"><dt className="text-[#4A5866]">Alumicom's role:</dt><dd className="min-w-0">{it.role}</dd></div>
          </dl>
        </>
      ) : (
        <>
          <p className="mt-3 text-sm font-semibold text-[#151A20] md:text-base">{it.system}</p>
          <p className="mt-1 text-[13px] text-[#2B3642] md:text-sm">{it.setting}</p>
        </>
      )}
    </figcaption>
  </figure>
);

export const Gallery = ({ items, zoomable = false, filters, testid = "gallery" }) => {
  const [index, setIndex] = useState(null);
  return (
    <>
      <ul className="grid grid-cols-2 gap-x-[10px] gap-y-7 md:gap-x-5 md:gap-y-10" data-testid={testid}>
        {items.map((it, i) => (
          <li key={it.name}>
            <Reveal delay={(i % 3) * 0.06} className="h-full">
              {zoomable ? (
                <button type="button" className="block h-full w-full cursor-zoom-in text-left focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#102A43]" onClick={() => setIndex(i)} aria-label={`Open image: ${it.system || it.setting}`} data-testid={`${testid}-item-${i}`}><WorkCard it={it} /></button>
              ) : <WorkCard it={it} />}
            </Reveal>
          </li>
        ))}
      </ul>
      {zoomable && <Lightbox items={items} filters={filters} start={index} onClose={() => setIndex(null)} testid={`${testid}-lightbox`} />}
    </>
  );
};
